<template>
    <div v-if="mostrar" class="modal-mask" @click="$emit('fechar')">
        <div style="height: 85%; width: 50rem; padding: 1rem 2rem; overflow: auto;" class="jm" @click.stop>
            <div>
                <h2>Compartilhar: {{ plano.nome }} </h2>
                <hr>
                <br>
            </div>
            <div style="width: 100%; display: flex; justify-content: center;">
                <div style="display: flex; flex-flow: column; width: 100%; height: 10rem;">
                    <input type="text" v-model="pessoaSelecionada" class="form-control"
                        @focusin="listaAberta = true" @input="listaAberta = true"
                        @focusout="fecharLista" placeholder="Adicionar Participante">

                    <div v-if="listaAberta"
                        style="height: fit-content; max-height: 15rem; overflow: auto; background-color: var(--cor-bg); border: 2px solid var(--cor-separador); border-bottom-left-radius: 4px; border-bottom-right-radius: 4px; position: absolute; margin-top: 3.5rem; width: 30rem;">
                        <ul style="list-style: none;">
                            <li @click="onAdicionar(item)" v-for="item in listaPessoasFiltrada" :key="item.id">
                                <div style="display: flex; align-items: center; padding: 5px; border-radius: 10px; margin-right: 3rem;"
                                    :style="{ 'color': jaAdicionado(item) ? 'grey' : 'black', 'cursor': jaAdicionado(item) ? 'not-allowed' : '' }">
                                    {{ item.nomeCompleto }} {{ jaAdicionado(item) ? "(Já adicionado)" : "" }}
                                </div>
                            </li>
                        </ul>
                    </div>

                    <br>
                    <h3>Pessoas com acesso:</h3>
                    <ul style="list-style: none;">
                        <li v-for="item in permissaoOrdenada" :key="item.usuario_id"
                            style="display: flex; align-items: center;">
                            <div
                                style="display: flex; border: 1px solid var(--cor-separador); height: 2.5rem; align-items: center; justify-content: space-between; padding: 5px; border-radius: 10px; width: 90%; margin-top: 0.3rem;">
                                {{ item.nome }}
                                {{ item.usuario_id == plano.gerente_id ? "(Gerente)" : item.usuario_id == idUsuario ? "(Você)" : "" }}
                                <select
                                    style="width: 6rem; text-align: center; height: 2rem; padding: 0; padding-right: 1rem"
                                    v-model="item.nivel" @change="$emit('atualizar', item)"
                                    :disabled="item.usuario_id == plano.gerente_id || item.usuario_id == idUsuario">
                                    <option :value="1">Leitor</option>
                                    <option :value="2">Editor</option>
                                </select>
                            </div>
                            <i v-if="parseInt(item.usuario_id) !== parseInt(idUsuario) && parseInt(item.usuario_id) !== parseInt(plano.gerente_id)"
                                @click="$emit('remover', item)"
                                style="margin-left: 1rem; font-size: 20px; color: red;"
                                class="bi bi-dash-circle botaoAdicionarSprint"></i>
                        </li>
                        <br><br><br>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ModalCompartilharPlanoPAP",
    props: {
        mostrar: { type: Boolean, default: false },
        plano: { type: Object, required: true },
        gerente: { type: Array, default: () => [] },
        idUsuario: { type: [Number, String], required: true },
    },
    emits: ["fechar", "adicionar", "remover", "atualizar"],
    data() {
        return {
            pessoaSelecionada: "",
            listaAberta: false,
        };
    },
    computed: {
        listaPessoasFiltrada() {
            if (!this.pessoaSelecionada) return this.gerente;
            const texto = this.pessoaSelecionada.toLowerCase();
            return this.gerente.filter((p) => (p.nomeCompleto || "").toLowerCase().includes(texto));
        },
        permissaoOrdenada() {
            const perm = this.plano.permissao || [];
            const gerenteId = this.plano.gerente_id;
            const primeiro = perm.find((p) => parseInt(p.usuario_id) === parseInt(gerenteId));
            const restante = perm.filter((p) => parseInt(p.usuario_id) !== parseInt(gerenteId));
            return primeiro ? [primeiro, ...restante] : perm;
        },
    },
    methods: {
        jaAdicionado(item) {
            return (this.plano.permissao || []).map((p) => p.usuario_id).includes(item.id);
        },
        fecharLista() {
            setTimeout(() => { this.listaAberta = false; }, 200);
        },
        onAdicionar(item) {
            if (!this.jaAdicionado(item)) this.$emit("adicionar", item);
        },
    },
};
</script>
